import { environment } from '@environment';
import analyticsStructure from 'analytics.structure.json';
import { EndpointHelper } from 'core/services/endpoint.helper';
import { HttpClient } from 'core/services/http';

export class AnalyticsStructureService {
  private static analyticsStructureApiBuilder = new EndpointHelper(`${environment.ANALYTICS_STRUCTURE_API_URL}`);

  public static async getAnalyticsStructure() {
    const useApi = environment.ANALYTICS_STRUCTURE_USE_API.toLocaleLowerCase();

    if (useApi === "false" || useApi === "") {
      return analyticsStructure;
    }

    const url = this.analyticsStructureApiBuilder.createUrl().build();

    try {
      const data = (await HttpClient.GetInstance.get<any>(url)).data

      return data.components
        ? data
        : analyticsStructure;
    }
    catch (e) {
      return analyticsStructure;
    }
  }
}